import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "../app";
import { Api } from "../app-api";
import { Cart, Child } from "../app-cart";
import { Gtm } from "../app-gtm";

const divRoot: HTMLDivElement = document.querySelector("#ko-options");
const divModel: HTMLDivElement = document.querySelector("#divRegisterOptionsModel");

export class ViewModel {
    children: Child[];

    busy = ko.observable(false);
    cart = ko.observable<Cart>();

    next: () => void;
    showDonation: () => void;

    constructor(model: any) {
        let self = this;

        const data = JSON.parse(model);

        self.cart(new Cart(data.cart, data.returnUrl));
        self.children = _(data.children).map(x => new Child(x));

        _(self.cart().registrations()).each(x => {
            if (x.child) {
                x.selectedChild = _(self.children).find(y => y.id === x.child.id);
            }
            else if (self.children.length === 1) {
                x.selectedChild = self.children[0];
            }
        });

        self.busy.subscribe(newVal => App.busy(newVal));

        self.next = () => {
            if (!self.busy())
                self.options();
        }

        self.showDonation = () => {
            Api.GetDonationInfo()
                .done(results => {
                    App.showInfo(results, "Donation");
                });
        }

        Gtm.options();

        App.onEnter("#optionsSection", self.next);
    }

    private toJson() {
        let self = this;

        return {
            region: self.cart().region.id,
            options: _(self.cart().registrations()).map(x => {
                return {
                    id: x.id,
                    program: x.camp.program.id,
                    child: x.selectedChild ? {
                        id: x.selectedChild.id,
                        birthDate: x.selectedChild.birthDate,
                        name: x.selectedChild.name
                    } : null,
                    startDate: x.camp.startDate,
                    skillLevel: x.selectedSkillLevel ? {
                        id: x.selectedSkillLevel.id,
                        minAge: x.selectedSkillLevel.minAge,
                        name: x.selectedSkillLevel.name
                    } : null,
                    products: _(x.selectedProducts()).pluck("id"),
                    extraCare: _(x.selectedExtraCare()).pluck("id")
                }
            })
        }
    }

    private options() {
        let self = this;

        self.busy(true);

        const data = self.toJson();

        Api.Options(data)
            .done(results => {
                if (results.error) { return App.alertError(results.message); }
                if (!App.isValid(results.valid)) { return App.alertWarning(results.message); }
                window.location.href = results.nextUrl;
            })
            .always(() => self.busy(false));
    }
}

function init() {
    if (divModel) {
        ko.applyBindings(new ViewModel(divModel.textContent), divRoot);
    }
}

$(document).ready(() => init());